/**
 * Created by 王国栋 wgdsk on 2018/6/10.
 */
import Vue from 'vue'
import Router from 'vue-router'

import Main from './views/main.vue'
import Class from './components/class'
import Cart from './components/cart'
import Pay from './components/pay'
import Payfortheorder from './components/payfortheorder'
import Ordercenter from './components/ordercenter'
import User from './components/user'
import Course from './components/course'
import Search from './components/search'


Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Main',
            component: Main
        },
        {
            path: '/class',
            name: 'Class',
            component: Class
        },
        {
            path: '/cart',
            name: 'Cart',
            component: Cart
        },
        {
            path: '/pay',
            name: 'Pay',
            component: Pay
        },
        {
            path: '/Payfortheorder',
            name: 'Payfortheorder',
            component: Payfortheorder
        },
        {
            path: '/Ordercenter',
            name: 'Ordercenter',
            component: Ordercenter
        },
        {
            path: '/User',
            name: 'User',
            component: User
        },
        {
            path: '/Course',
            name: 'Course',
            component: Course
        },
        {
            path: '/Search/:id',
            name: 'Search',
            component: Search
        },
        {
            path: '/Search',
            name: 'Search',
            component: Search
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})
